import {
	defineEFFeature,
	type EFFeatureDefinition,
} from "@/features/runtime/FeatureDefinition";
import {
	renderCaptainUpMissionDock,
	renderCaptainUpTournamentDock,
} from "@/features/runtime/FeatureRenderers";

export const FEATURE_CATALOG: readonly EFFeatureDefinition[] = [
	defineEFFeature({
		id: "captainup.mission",
		displayName: "CaptainUp Mission",
		capabilities: {
			usesDock: true,
			usesPopup: true,
			listensToRewards: true,
		},
		eligibility: {
			requiresHostConfigured: true,
			requiresGameReady: false,
			requiresProviderReady: true,
			supportedProviders: ["captainup"],
		},
		defaultDockTarget: "mission",
		supportedSurfaces: ["dock", "popup"],
		snapshotWidgetId: "_cpt_popup9_ruby_missions",
		renderer: {
			renderDock: renderCaptainUpMissionDock,
		},
	}),
	defineEFFeature({
		id: "captainup.tournament",
		displayName: "CaptainUp Tournament",
		capabilities: {
			usesDock: true,
			usesPopup: true,
			listensToRewards: true,
		},
		eligibility: {
			requiresHostConfigured: true,
			requiresGameReady: false,
			requiresProviderReady: true,
			supportedProviders: ["captainup"],
		},
		defaultDockTarget: "tournament",
		supportedSurfaces: ["dock", "popup"],
		snapshotWidgetId: "_cpt_popup9_tournament",
		renderer: {
			renderDock: renderCaptainUpTournamentDock,
		},
	}),
] as const;